import reactViewGenerator from '../../simple-flow/react-view-generator';
import MapTemplate from './map-template';
import mapContainerFactory from './map-container';
import appDirector from '../../managers/app-director';

const eventManager = appDirector.getEventManager();

const MapView = reactViewGenerator({
    containerFactory: mapContainerFactory,
    Template: MapTemplate,
    manager: eventManager,
});

export default MapView;
